export default {
  api_r_user_module_environmentalAspectsAssessment_getModuleData: {
    path: 'm/environmental-aspects-assessment/get-module-data/',
  },
  api_r_user_module_environmentalAspectsAssessment_getPermissions: {
    path: 'm/environmental-aspects-assessment/get-permissions/',
  },
  api_r_user_module_environmentalAspectsAssessment_assessment_get: {
    path: 'm/environmental-aspects-assessment/assessment/get/',
  },
  api_r_user_module_environmentalAspectsAssessment_assessment_add: {
    path: 'm/environmental-aspects-assessment/assessment/add/',
  },
  api_r_user_module_environmentalAspectsAssessment_assessment_edit: {
    path: 'm/environmental-aspects-assessment/assessment/edit/',
  },
  api_r_user_module_environmentalAspectsAssessment_assessment_toggleClose: {
    path: 'm/environmental-aspects-assessment/assessment/toggle-close/',
  },
  api_r_user_module_environmentalAspectsAssessment_assessment_log_list: {
    path: 'm/environmental-aspects-assessment/assessment/log/list/',
  },
  api_r_user_module_environmentalAspectsAssessment_assessment_log_edit: {
    path: 'm/environmental-aspects-assessment/assessment/log/edit/',
  },
  api_r_user_module_environmentalAspectsAssessment_assessment_log_delete: {
    path: 'm/environmental-aspects-assessment/assessment/log/delete/',
  },
  api_r_user_module_environmentalAspectsAssessment_assessment_inspection_check: {
    path: 'm/environmental-aspects-assessment/assessment/inspection/check/',
  },
  api_r_user_module_environmentalAspectsAssessment_tipology_list: {
    path: 'm/environmental-aspects-assessment/tipology/list/',
  },
  api_r_user_module_environmentalAspectsAssessment_inspection_list: {
    path: 'm/environmental-aspects-assessment/inspection/list/',
  },
  api_r_user_module_environmentalAspectsAssessment_inspection_get: {
    path: 'm/environmental-aspects-assessment/inspection/get/',
  },
  api_r_user_module_environmentalAspectsAssessment_inspection_add: {
    path: 'm/environmental-aspects-assessment/inspection/add/',
  },
  api_r_user_module_environmentalAspectsAssessment_inspection_edit: {
    path: 'm/environmental-aspects-assessment/inspection/edit/',
  },
  api_r_user_module_environmentalAspectsAssessment_inspection_evaluation_list: {
    path: 'm/environmental-aspects-assessment/inspection/evaluation/list/',
  },
  api_r_user_module_environmentalAspectsAssessment_inspection_evaluation_add: {
    path: 'm/environmental-aspects-assessment/inspection/evaluation/add/',
  },
  api_r_user_module_environmentalAspectsAssessment_inspection_evaluation_edit: {
    path: 'm/environmental-aspects-assessment/inspection/evaluation/edit/',
  },
  api_r_user_module_environmentalAspectsAssessment_inspection_evaluation_download: {
    path: 'm/environmental-aspects-assessment/inspection/evaluation/download/',
  },
  api_r_user_module_environmentalAspectsAssessment_inspection_evaluation_aspect_list: {
    path: 'm/environmental-aspects-assessment/inspection/evaluation/aspect/list/',
  },
  api_r_user_module_environmentalAspectsAssessment_tipology_list: {
    path: 'm/environmental-aspects-assessment/tipology/list/',
  },
  api_r_user_module_environmentalAspectsAssessment_assessment_clone: {
    path: 'm/environmental-aspects-assessment/assessment/clone/',
  },
  api_r_user_module_environmentalAspectsAssessment_inspection_aspect_list: {
    path: 'm/environmental-aspects-assessment/inspection/aspect/list/',
  },
};
